import NurseNav from "../../pages/Dashboard/Nurse/NurseNav";
import NurseIndex from "../../pages/Dashboard/Nurse/NurseIndex";
import MyPatients from "../../pages/Dashboard/Nurse/MyPatients/MyPatients";
import VitalSignsPage from "../../pages/Dashboard/Nurse/VitalSigns/VitalSignsPage";
import NursingNotes from "../../pages/Dashboard/Nurse/NursingNotes/NursingNotes";
import MedicationsPage from "../../pages/Dashboard/Nurse/Medications/MedicationsPage";
import ShiftHandoverPage from "../../pages/Dashboard/Nurse/ShiftHandover/ShiftHandoverPage";

const nurseRoutes = {
  path: "/nurse",
  element: <NurseNav />,
  children: [
    { path: "/nurse", element: <NurseIndex /> },
    { path: "/nurse/my-patients", element: <MyPatients /> },
    { path: "/nurse/vital-signs", element: <VitalSignsPage /> },
    { path: "/nurse/nursing-notes", element: <NursingNotes /> },
    { path: "/nurse/medications", element: <MedicationsPage /> },
    { path: "/nurse/shift-handover", element: <ShiftHandoverPage /> },
  ],
};

export default nurseRoutes;
